import React, { useState } from "react";
import "./ContactForm.css";

const ContactForm = () => {
  const [form, setForm] = useState({
    firstName: "",
    phone: "",
    email: "",
    company: "",
    description: "",
    success:false,
  });

  const [errors, setErrors] = useState({});
const [successMessage, setSuccessMessage] = useState("");

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });

    setErrors({
      ...errors,
      [e.target.name]: "",
    });
  };

  const validate = () => {
    let temp = {};

    if (!form.firstName.trim())
      temp.firstName = "First Name is required";

    if (!form.phone.trim())
      temp.phone = "Phone Number is required";
    else if (!/^[0-9]{10}$/.test(form.phone))
      temp.phone = "Enter a valid 10-digit phone number";

    if (!form.email.trim())
      temp.email = "Email is required";
    else if (!/\S+@\S+\.\S+/.test(form.email))
      temp.email = "Enter a valid email";

    if (!form.company.trim())
      temp.company = "Company Name is required";

    if (!form.description.trim())
      temp.description = "Description is required";

    setErrors(temp);

    return Object.keys(temp).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validate()) {
      console.log(form);
    setSuccessMessage("Thank you for Contact Us, We will get back soon");


      setForm({
        firstName: "",
        phone: "",
        email: "",
        company: "",
        description: "",
      });

       // Hide success message after 5 seconds
    setTimeout(() => {
      setSuccessMessage("");
    }, 5000);
    
    }
  };

  return (
    <div className="contact-container">
      <form className="contact-form" onSubmit={handleSubmit}>


         

         {successMessage && (
  <div className="success_input">
    {successMessage}
  </div>
)}

        <div className="form-group">
          <label>First Name</label>
          <input
            type="text"
            name="firstName"
            value={form.firstName}
            onChange={handleChange}
          />
          <span>{errors.firstName}</span>
        </div>

        <div className="form-group">
          <label>Phone Number</label>
          <input
            type="tel"
            name="phone"
            value={form.phone}
            onChange={handleChange}
          />
          <span>{errors.phone}</span>
        </div>

        <div className="form-group">
          <label>Email</label>
          <input
            type="email"
            name="email"
            value={form.email}
            onChange={handleChange}
          />
          <span>{errors.email}</span>
        </div>

        <div className="form-group">
          <label>Company Name</label>
          <input
            type="text"
            name="company"
            value={form.company}
            onChange={handleChange}
          />
          <span>{errors.company}</span>
        </div>

        <div className="form-group">
          <label>Description</label>
          <textarea
            rows="5"
            name="description"
            value={form.description}
            onChange={handleChange}
          />
          <span>{errors.description}</span>
        </div>

        <button type="submit">
          Send Message
        </button>

      </form>
    </div>
  );
};

export default ContactForm;